
import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'

@Component({})
export default class extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'RightDrawer'

  @Prop({ type: Boolean, default: false }) show: boolean = false

  @Prop({ type: String, default: '' }) title: string
}
